import { Box, Typography } from '@mui/material';

export default function TimeColumn({ hours }: { hours: string[] }) {
  return (
    <Box
      sx={{
        minWidth: '80px',
        borderRight: '1px solid',
        borderColor: 'divider',
      }}
    >
      {hours.map((hour, hourIndex) => (
        <Box
          key={hour}
          sx={{
            p: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '60px',
            borderBottom: hourIndex < hours.length - 1 ? '1px solid' : 'none',
            borderColor: 'divider',
          }}
        >
          <Typography variant="body2" color="primary.main">
            {hour}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
